import { ANTIRUG_CA } from '@/constants/antirug';
export const selfCheckInputs = [
  ANTIRUG_CA,
  'ts3folrnumvwdveit1onelwjyk7e4qsn8pqssqrpump',
  'antirug',
  '$antirug',
];
